<template>
    <div>
        <div class="KPI-title">KPI</div>
        <!-- KPI概览 -->
        <Row>
            <Col span="24">
                <Row style="width: 100%;background-color: #fff;height: 53px;padding-top: 7px;">
                    <Col span="24">
                        <Row :gutter="10">
                            <!-- 公司 -->
                            <Col span="6" v-if="companyId==1">
                                <Select v-model="companyIds" filterable @on-change="companyIdChange(companyIds)" :placeholder="$t('KPI.pleaseSelectCompany')">
                                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                                    <Option v-for="item in companyIdList" :value="item.id" :key="item.id">{{ item.companyName}}</Option>
                                </Select>
                            </Col>
                            <!-- 运维工程师 -->
                            <Col span="6" v-if="companyId==1">
                                <Select v-model="operationMaintenance" filterable @on-change="operationMaintenanceChange(operationMaintenance)" :placeholder="$t('KPI.pleaseSelectOperation')">
                                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                                    <Option v-for="item in operationMaintenanceList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                </Select>
                            </Col>
                            <!-- 年月 -->
                            <Col span="6">
                                <DatePicker type="month" format="yyyy-MM-dd" v-model="monthKPI" :placeholder="$t('KPI.pleaseSelectDate')" style="width: 100%;" @on-change="monthKPI=$event,searchMonthKPI(monthKPI)"></DatePicker>
                            </Col>
                            <!-- 导出 -->
                            <Col style="float:right;font-size: 20px;cursor: pointer;padding-right: 10px;">
                                <Icon type="ios-cloud-download-outline" class="download" @click="ticketKPIDownload"/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>

        <Row :gutter="10" style="margin-bottom: 10px;">
            <Col span="6">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{ $t('KPI.p1event') }}</Col>
                    </Row>
                    <Row>
                        <Col span="24" style="text-align: center;">
                            <i-circle :percent=p1finishStatusTicketPercentage stroke-color="#ed4014">
                                <div>
                                    <span style="font-size:24px;"><i>{{p1finishStatusTicketPercentage}}%</i></span>
                                    <p style="font-size:12px;">{{ $t('KPI.closed') }}({{p1finishStatusTicket}})</p>
                                </div>
                            </i-circle>
                        </Col>
                    </Row>
                    <Row style="font-size: 13px;padding: 8px;">
                        <Col span="24">
                            <Row :gutter="16">
                                <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.pending') }}</Col>
                                        <Col><a @click="pendingP1">{{p1pendingStatusTicket}}</a> ({{p1pendingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                                <Col span="8" padding-right= "10px">
                                    <Row>
                                        <Col>{{ $t('KPI.responseTime') }}</Col>
                                        <Col>{{p1AverageResponseTime}} Min</Col>
                                    </Row>
                                </Col>
                                <Col span="8">
                                    <Row style="text-align: right;">
                                        <Col>{{ $t('KPI.processing') }}</Col>
                                        <Col><a @click="processingP1">{{p1ProcessingStatusTicket}}</a> ({{p1ProcessingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{ $t('KPI.p2event') }}</Col>
                    </Row>
                    <Row>
                        <Col span="24" style="text-align: center;">
                            <i-circle :percent=p2finishStatusTicketPercentage stroke-color="#ff9900">
                                <div>
                                    <span style="font-size:24px;"><i>{{p2finishStatusTicketPercentage}}%</i></span>
                                    <p style="font-size:12px;">{{ $t('KPI.closed') }}({{p2finishStatusTicket}})</p>
                                </div>
                            </i-circle>
                        </Col>
                    </Row>
                    <Row style="font-size: 13px;padding: 8px;">
                        <Col span="24">
                            <Row :gutter="16">
                                <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.pending') }}</Col>
                                        <Col><a @click="pendingP2">{{p2pendingStatusTicket}}</a> ({{p2pendingStatusTickePercentage}}%)</Col>
                                    </Row>
                                </Col>
                                <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.responseTime') }}</Col>
                                        <Col>{{p2AverageResponseTime}} Min</Col>
                                    </Row>
                                </Col>
                                <Col span="8">
                                    <Row style="text-align: right;">
                                        <Col>{{ $t('KPI.processing') }}</Col>
                                        <Col><a @click="processingP2">{{p2ProcessingStatusTicket}}</a> ({{p2ProcessingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{ $t('KPI.p3event') }}</Col>
                    </Row>
                    <Row>
                        <Col span="24" style="text-align: center;">
                            <i-circle :percent=p3finishStatusTicketPercentage stroke-color="#19be6b">
                                <div>
                                    <span style="font-size:24px;"><i>{{p3finishStatusTicketPercentage}}%</i></span>
                                    <p style="font-size:12px;">{{ $t('KPI.closed') }}({{p3finishStatusTicket}})</p>
                                </div>
                            </i-circle>
                        </Col>
                    </Row>
                    <Row style="font-size: 13px;padding: 8px;">
                        <Col span="24">
                            <Row :gutter="16">
                                <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.pending') }}</Col>
                                        <Col><a @click="pendingP3">{{p3pendingStatusTicket}}</a> ({{p3pendingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                               <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.responseTime') }}</Col>
                                        <Col>{{p3AverageResponseTime}} Min</Col>
                                    </Row>
                                </Col>
                                <Col span="8">
                                    <Row style="text-align: right;">
                                        <Col>{{ $t('KPI.processing') }}</Col>
                                        <Col><a @click="processingP3">{{p3ProcessingStatusTicket}}</a> ({{p3ProcessingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{ $t('KPI.p4event') }}</Col>
                    </Row>
                    <Row>
                        <Col span="24" style="text-align: center;">
                            <i-circle :percent=p4finishStatusTicketPercentage>
                                <div>
                                    <span style="font-size:24px;"><i>{{p4finishStatusTicketPercentage}}%</i></span>
                                    <p style="font-size:12px;">{{ $t('KPI.closed') }}({{p4finishStatusTicket}})</p>
                                </div>
                            </i-circle>
                        </Col>
                    </Row>
                    <Row style="font-size: 13px;padding: 8px;">
                        <Col span="24">
                            <Row :gutter="16">
                                <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.pending') }}</Col>
                                        <Col><a @click="pendingP4">{{p4pendingStatusTicket}}</a> ({{p4pendingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                                <Col span="8">
                                    <Row>
                                        <Col>{{ $t('KPI.responseTime') }}</Col>
                                        <Col>{{p4AverageResponseTime}} Min</Col>
                                    </Row>
                                </Col>
                                <Col span="8">
                                    <Row style="text-align: right;">
                                        <Col>{{ $t('KPI.processing') }}</Col>
                                        <Col><a @click="processingP4">{{p4ProcessingStatusTicket}}</a> ({{p4ProcessingStatusTicketPercentage}}%)</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>

        <Row :gutter="10" style="margin-bottom: 10px;">
            <Col span="8">
                <Card :padding="8">
                    <Row>
                        <Col>
                            <Row>
                                <Col span="12" class="title">{{ $t('KPI.totalEvent') }}</Col>
                                 <!-- 筛选 -->
                                <Col span="12">
                                    <Select v-model="totalNumberOfEvents" filterable style="width:150px;float: right;margin-top: 6px;" @on-change="totalNumberOfEventsChange(totalNumberOfEvents)">
                                        <Option v-for="item in eventCountList" :value="item.id" v-bind:key="item.id">{{ item.name }}</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="totalEvents" style="width:100%;height:300px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="8">
                <Card :padding="8">
                    <Row>
                        <Col>
                            <Row>
                                <Col span="24" class="title">{{ $t('KPI.eventChangingTrendingStatistic') }}</Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="eventChangeTrend" style="width:100%;height: 300px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="8">
                <Card :padding="8">
                    <Row>
                        <Col>
                            <Row>
                                <Col span="12" class="title">{{ $t('KPI.casesSLAStatistic') }}</Col>
                                 <!-- 筛选 -->
                                <Col span="12">
                                    <Select v-model="priorityId" filterable :placeholder="$t('satisfaction.searchByPriority')" :transfer="true" @on-change="searchPriority()" style="width:150px;float: right;margin-top: 6px;">
                                        <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                                        <Option :value="item.id" v-for="item in priorityIdList" :key="item.id">{{item.name}}</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="averageResponseTime" style="width:100%;height:280px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <!-- 待处理和正在处理详情 -->
        <Modal v-model="pendingProcessingModel" :title="$t('KPI.viewProcessingDetails')" :mask-closable="false" width="800px;">
            <Table :no-data-text="$t('common.noData')" :columns="columnPendingProcessing" :data="pendingProcessingData" :height="400" :loading="pendProcessingLoading"></Table>
            <div slot="footer"></div>
        </Modal>
        <!-- 案例统计&公司贡献 -->
        <Row style="margin-bottom: 10px;" v-if="companyId==1">
            <Col span="24">
                <Card :padding="8">
                    <Row :gutter="4">
                        <Col span="4" class="title" style="margin-top: -2px;">{{ $t('KPI.casesStatistic') }}</Col>
                        <!-- 系数 -->
                        <Col span="7">
                            <Row :gutter="10">
                                <Col span="14" style="text-align: right;font-size: 13px;line-height: 31px;">{{ $t('KPI.nightFactor') }}</Col>
                                <Col span="10">
                                    <InputNumber :min="1" v-model="coefficient" style="width: 100%;" @on-blur="coefficientChange"></InputNumber>
                                </Col>
                            </Row>
                        </Col>
                        <!-- 白班/夜班 -->
                        <Col span="4">
                            <Select v-model="isDayShift" filterable @on-change="isDayShiftChange(isDayShift)" :placeholder="$t('KPI.pleaseSelectType')">
                                <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                                <Option v-for="item in isDayShiftList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                            </Select>
                        </Col>
                        <!-- 公司 -->
                        <Col span="4">
                            <Select v-model="companyIdTable" filterable @on-change="companyIdTableChange(companyIdTable)" :placeholder="$t('KPI.pleaseSelectCompany')">
                                <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                                <Option v-for="item in companyIdList" :value="item.id" :key="item.id">{{ item.companyName}}</Option>
                            </Select>
                        </Col>
                        <!-- 年月 -->
                        <Col span="4">
                            <DatePicker type="month" format="yyyy-MM-dd" v-model="monthTable" :placeholder="$t('KPI.pleaseSelectDate')" style="width: 110%;" @on-change="monthTable=$event, searchMonthTable(monthTable)"></DatePicker>
                        </Col>
                        <Col span="1" style="text-align:right;font-size: 20px;cursor: pointer;">
                            <Icon type="ios-cloud-download-outline" class="download" @click="ticketStatisticsDownload"/>
                        </Col>
                    </Row>
                    <!-- 案例统计 -->
                    <table class="kpi-table" cellpadding="0" cellspacing="0" style="margin-bottom: 15px;">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="item in ticketCellListLine">{{item}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in ticketCellListDTO">
                                <td style="width: 85px;">{{item.priority}}</td>
                                <td v-for="name in item.ticketProportions">{{name}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <Row :gutter="17">
                        <Col span="23" class="title">{{ $t('KPI.companyContribution') }}</Col>
                        <Col span="1" style="text-align:right;font-size: 20px;cursor: pointer;">
                            <Icon type="ios-cloud-download-outline" class="download" @click="ticketDocumentDownload"/>
                        </Col>
                    </Row>
                     <!-- 公司贡献 -->
                    <table class="kpi-table" cellpadding="0" cellspacing="0" style="margin-bottom: 15px;">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="item in documentLine">{{item}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in documentDTO">
                                <td style="width: 85px;">{{item.priority}}</td>
                                <td v-for="name in item.ticketProportions">{{name}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <Row :gutter="17">
                        <Col span="23" class="title">{{ $t('KPI.unsatisfiedSLACasesStatistic') }}</Col>
                        <Col span="1" style="text-align:right;font-size: 20px;cursor: pointer;">
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportSlaDetail"/>
                        </Col>
                    </Row>
                    <Table :no-data-text="$t('common.noData')" :columns="columns" :data="SLAData"></Table>
                </Card>
            </Col>
        </Row>
        <!-- SLA详情 -->
        <Modal v-model="slaDetailModel" :title="$t('KPI.viewSlaDetails')" :mask-closable="false" width="800px;">
            <Table :no-data-text="$t('common.noData')" :columns="columnSlaDetail" :data="SlaDetailData" :height="400" :loading="loading"></Table>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    export default {
        name: 'KPI',
        data(){
            return {
                isDayShift:'',
                companyId:getCookie(global.companyId),
                priorityId:'',
                isDayShiftList:[
                {
                    id:0,
                    name:this.$t('KPI.dayShift')
                },
                {
                    id:1,
                    name:this.$t('KPI.nightShift')
                }],
                priorityIdList:[
                  {
                      id:0,
                      name:'P1'
                  },
                  {
                      id:1,
                      name:'P2'
                  },
                  {
                      id:2,
                      name:'P3'
                  },
                  {
                      id:3,
                      name:'P4'
                  }
                ],
                coefficient:1.5,
                companyIdTable:'',
                chartAverageResponseTime:'',
                resultList:[],
                problemValueList:[],
                resultLists:[],
                problemValueLists:[],
                averageResponseTimes:'',
                totalNumberOfEvents: 0,
                eventCountList: [{
                    id: 0,
                    name: this.$t('KPI.problemType')
                },{
                    id: 1,
                    name: this.$t('KPI.whetherManual')
                }],
                totalEventsChart:'',
                chartEventChangeTrend:'',
                allStatusTicket:'',
                p1pendingStatusTicket:'',
                p1finishStatusTicket:'',
                p1ProcessingStatusTicket:'',
                p2pendingStatusTicket:'',
                p2finishStatusTicket:'',
                p2ProcessingStatusTicket:'',
                p3pendingStatusTicket:'',
                p3finishStatusTicket:'',
                p3ProcessingStatusTicket:'',
                p4pendingStatusTicket:'',
                p4finishStatusTicket:'',
                p4ProcessingStatusTicket:'',
                p1pendingStatusTicketPercentage:'',
                p1finishStatusTicketPercentage:0,
                p1ProcessingStatusTicketPercentage:'',
                p1AverageResponseTime:'',
                p2AverageResponseTime:'',
                p3AverageResponseTime:'',
                p4AverageResponseTime:'',
                p2pendingStatusTickePercentage:'',
                p2finishStatusTicketPercentage:0,
                p2ProcessingStatusTicketPercentage:'',
                p3pendingStatusTicketPercentage:'',
                p3finishStatusTicketPercentage:0,
                p3ProcessingStatusTicketPercentage:'',
                p4pendingStatusTicketPercentage:'',
                p4finishStatusTicketPercentage:0,
                p4ProcessingStatusTicketPercentage:'',  // KPI概览
                operationMaintenance:'',
                operationMaintenanceList:[],//运维工程师
                companyIds:'',
                companyIdList:[], // 公司
                monthKPI:'', //年月
                monthTable:'',
                ticketCellListDTO:[],
                ticketCellListLine:[], //案例统计表格
                documentLine:[],
                documentDTO:[], //案例统计表格
                slaDetailModel:false,
                loading:false,
                pendProcessingLoading:false,
                pendingProcessingModel:false,
                columns: [
                    {
                        title:  this.$t('KPI.name'),
                        key: 'name'
                    },
                    {
                        title: 'p1',
                        key: 'p1',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.loading=true;
                                        this.$api.ticket.getSlaDetails({
                                            "priorityId": 0,
                                            "assigneeUserName" : params.row.name,
                                            "startTime": this.monthTable,
                                            "companyId": this.companyIdTable
                                        })
                                        .then(res => {
                                            this.loading=false;
                                            this.slaDetailModel=true;
                                            this.SlaDetailData=res.data;
                                        })
                                    }
                                }
                            },params.row.p1);
                        }
                    },
                    {
                        title: 'p2',
                        key: 'p2',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.loading=true;
                                        this.$api.ticket.getSlaDetails({
                                            "priorityId": 1,
                                            "assigneeUserName" : params.row.name,
                                            "startTime": this.monthTable,
                                            "companyId": this.companyIdTable
                                        })
                                        .then(res => {
                                            this.loading=false;
                                            this.slaDetailModel=true;
                                            this.SlaDetailData=res.data;
                                        })
                                    }
                                }
                            },params.row.p2);
                        }
                    },
                    {
                        title: 'p3',
                        key: 'p3',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.loading=true;
                                        this.$api.ticket.getSlaDetails({
                                            "priorityId": 2,
                                            "assigneeUserName" : params.row.name,
                                            "startTime": this.monthTable,
                                            "companyId": this.companyIdTable
                                        })
                                        .then(res => {
                                            this.loading=false;
                                            this.slaDetailModel=true;
                                            this.SlaDetailData=res.data;
                                        })
                                    }
                                }
                            },params.row.p3);
                        }
                    },
                    {
                        title: 'p4',
                        key: 'p4',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.loading=true;
                                        this.$api.ticket.getSlaDetails({
                                            "priorityId": 3,
                                            "assigneeUserName" : params.row.name,
                                            "startTime": this.monthTable,
                                            "companyId": this.companyIdTable
                                        })
                                        .then(res => {
                                            this.loading=false;
                                            this.slaDetailModel=true;
                                            this.SlaDetailData=res.data;
                                        })
                                    }
                                }
                            },params.row.p4);
                        }
                    },
                    {
                        title:  this.$t('KPI.total'),
                        key: 'total',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.loading=true;
                                        this.$api.ticket.getSlaDetails({
                                            "priorityId": -1,
                                            "assigneeUserName" : params.row.name,
                                            "startTime": this.monthTable,
                                            "companyId": this.companyIdTable
                                        })
                                        .then(res => {
                                            this.loading=false;
                                            this.slaDetailModel=true;
                                            this.SlaDetailData=res.data;
                                        })
                                    }
                                }
                            },params.row.total);
                        }
                    }
                ],
                columnSlaDetail: [
                    {
                        title: this.$t('KPI.id'),
                        key: 'id'
                    },
                    {
                        title: this.$t('KPI.ticketEntityId'),
                        key: 'ticketEntityId',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({path:'/cases/caseDetail/',query: {id: params.row.id}});
                                    }
                                }
                            },params.row.ticketEntityId);
                        }

                    },
                    {
                        title: this.$t('KPI.subject'),
                        key: 'subject'
                    },
                    {
                        title: this.$t('KPI.priorityName'),
                        key: 'priorityName'
                    },
                    {
                        title: this.$t('KPI.slaStandard'),
                        key: 'slaStandard'
                    },
                    {
                        title: this.$t('KPI.waitTime'),
                        key: 'waitTime'
                    }
                ],
                columnPendingProcessing:[
                    {
                        title: this.$t('KPI.ticketEntityId'),
                        key: 'ticketEntityId',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({path:'/cases/caseDetail/',query: {id: params.row.id}});
                                    }
                                }
                            },params.row.ticketEntityId);
                        }

                    },
                    {
                        title: this.$t('KPI.subject'),
                        key: 'subject'
                    },
                    {
                        title: this.$t('KPI.priorityName'),
                        key: 'priorityName'
                    },
                    {
                        title: this.$t('KPI.statusName'),
                        key: 'statusName'
                    },
                    {
                        title: this.$t('KPI.ticketCategoryName'),
                        key: 'ticketCategoryName'
                    }
                ],
                pendingProcessingData:[],
                SLAData:[],
                SlaDetailData:[],
                trendTimeList:[],
                p1EventTrend:[],
                p2EventTrend:[],
                p3EventTrend:[],
                p4EventTrend:[],
                sumEventTrend:[]
            }
        },
        mounted(){
            this.init();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartEventChangeTrend.resize();
                self.totalEventsChart.resize();
                self.chartAverageResponseTime.resize();
            });
            this.getTicketByTime();
            this.getUserByDepartment();
            this.listRegisterInformation();
            this.getTicketStatistics();
            this.getCompanyContributionStatistics();
            this.getSlaStatistics();
        },
        created(){
            this.$nextTick(function() {
                this.getTicketTrend();
                this.queryTicketByType();
                this.getSlaTicketAnalyzeStatistics();
            });
        },
        methods:{
            /************************************KPI概览******************************************/
            getTicketByTime:function(){
                this.$api.ticket.getTicketByTime({
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    //p1等待处理
                    this.p1pendingStatusTicket=res.data.P1.pendingNum;
                    //p1完成
                    this.p1finishStatusTicket=res.data.P1.finishNum;
                    //p1处理中
                    this.p1ProcessingStatusTicket=res.data.P1.processNum;
                    //p1等待处理的百分比
                    this.p1pendingStatusTicketPercentage=res.data.P1.pendingProportion;
                    //p1完成的百分比
                    this.p1finishStatusTicketPercentage=res.data.P1.finishProportion;
                    //p1处理中的百分比
                    this.p1ProcessingStatusTicketPercentage=res.data.P1.processProportion;
                    // 平均响应时间
                    this.p1AverageResponseTime=res.data.P1.averageResponseTime;

                    //p2等待处理
                    this.p2pendingStatusTicket=res.data.P2.pendingNum;
                    //p2完成
                    this.p2finishStatusTicket=res.data.P2.finishNum;
                    //p2处理中
                    this.p2ProcessingStatusTicket=res.data.P2.processNum;
                    //p2等待处理的百分比
                    this.p2pendingStatusTickePercentage=res.data.P2.pendingProportion;
                    //p2完成的百分比
                    this.p2finishStatusTicketPercentage=res.data.P2.finishProportion;
                    //p2处理中的百分比
                    this.p2ProcessingStatusTicketPercentage=res.data.P2.processProportion;
                    // 平均响应时间
                    this.p2AverageResponseTime=res.data.P2.averageResponseTime;

                    //p3等待处理
                    this.p3pendingStatusTicket=res.data.P3.pendingNum;
                    //p3完成
                    this.p3finishStatusTicket=res.data.P3.finishNum;
                    //p3处理中
                    this.p3ProcessingStatusTicket=res.data.P3.processNum;
                    //p3等待处理的百分比
                    this.p3pendingStatusTicketPercentage=res.data.P3.pendingProportion;
                    //p3完成的百分比
                    this.p3finishStatusTicketPercentage=res.data.P3.finishProportion;
                    //p3处理中的百分比
                    this.p3ProcessingStatusTicketPercentage=res.data.P3.processProportion;
                    // 平均响应时间
                    this.p3AverageResponseTime=res.data.P3.averageResponseTime;

                    //p4等待处理
                    this.p4pendingStatusTicket=res.data.P4.pendingNum;
                    //p4完成
                    this.p4finishStatusTicket=res.data.P4.finishNum;
                    //p4处理中
                    this.p4ProcessingStatusTicket=res.data.P4.processNum;
                    //p4等待处理的百分比
                    this.p4pendingStatusTicketPercentage=res.data.P4.pendingProportion;
                    //p4完成的百分比
                    this.p4finishStatusTicketPercentage=res.data.P4.finishProportion;
                    //p4处理中的百分比
                    this.p4ProcessingStatusTicketPercentage=res.data.P4.processProportion;
                    // 平均响应时间
                    this.p4AverageResponseTime=res.data.P4.averageResponseTime;
                })
            },
            /*********************运维工程师************************/
            // 运维工程师
            getUserByDepartment:function(){
                this.$api.user.getUserByDepartment({
                    "companyId":1,
                    "department":1
                })
                .then(res => {
                    this.operationMaintenanceList=res.data;
                })
            },
            // 切换运维工程师
            operationMaintenanceChange:function(){
                this.getTicketByTime();
                this.getTicketTrend();
                this.queryTicketByType();
                this.getSlaTicketAnalyzeStatistics();
            },
            /*********************公司************************/
            // 公司
            listRegisterInformation: function () {
                this.$api.user.listRegisterInformation()
                .then(res => {
                    // 获取公司列表数据
                    this.companyIdList = res.data.companies;
                })
            },
            // 切换公司
            companyIdChange:function(){
                this.getTicketByTime();
                this.getTicketTrend();
                this.queryTicketByType();
                this.getSlaTicketAnalyzeStatistics();
            },
            /*********************年月************************/
            // 切换年月
            searchMonthKPI:function(){
                this.getTicketByTime();
                this.queryTicketByType();
                this.getSlaTicketAnalyzeStatistics();
            },
            /*********************导出************************/
            ticketKPIDownload: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.ticket.exportTicketKPI({
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    let fileName = 'TicketList.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            /************************************待处理******************************************/
            pendingP1:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 0,
                    "priorityId": 0,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            pendingP2:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 0,
                    "priorityId": 1,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            pendingP3:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 0,
                    "priorityId": 2,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            pendingP4:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 0,
                    "priorityId": 3,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            /************************************正在处理******************************************/
            processingP1:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 1,
                    "priorityId": 0,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            processingP2:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 1,
                    "priorityId": 1,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            processingP3:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 1,
                    "priorityId": 2,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            processingP4:function(){
                this.pendingProcessingData=[];
                this.pendingProcessingModel=true;
                this.pendProcessingLoading=true;
                this.$api.ticket.getTicketListByStatus({
                    "status": 1,
                    "priorityId": 3,
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.pendProcessingLoading=false;
                    this.pendingProcessingData=res.data;
                })
            },
            /******************图表********************************/
            // 查询案例平均响应时间
            getTicketTrend: function(){
                this.$api.ticket.getTicketTrend({
                    "companyId": this.companyIds,
                    "assigneeUserId":this.operationMaintenance
                })
                .then(res => {
                    this.trendTimeList=res.data.trendTimeList;
                    this.p1EventTrend=res.data.p1EventTrend;
                    this.p2EventTrend=res.data.p2EventTrend;
                    this.p3EventTrend=res.data.p3EventTrend;
                    this.p4EventTrend=res.data.p4EventTrend;
                    this.sumEventTrend=res.data.sumEventTrend;
                    this.init();
                })
            },
            // 事件总数
            queryTicketByType: function(){
                this.$api.ticket.queryTicketByType({
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance,
                    "option":this.totalNumberOfEvents
                })
                .then(res => {
                    this.resultList=res.data.resultList;
                    this.allStatusTicket=res.data.allStatusTicket;
                    this.problemValueList=res.data.problemValueList;
                    this.init();
                })
            },
             // 各级别案例SLA分析统计图
            getSlaTicketAnalyzeStatistics: function(){
                this.$api.ticket.getSlaTicketAnalyzeStatistics({
                    "companyId": this.companyIds,
                    "startTime": this.monthKPI,
                    "assigneeUserId":this.operationMaintenance,
                    "priorityId":this.priorityId
                })
                .then(res => {
                    this.resultLists=res.data.resultList;
                    this.problemValueLists=res.data.problemValueList;
                    this.averageResponseTimes=res.data.averageResponseTime;
                    this.init();
                })
            },
            // 切换事件总数
            totalNumberOfEventsChange:function(){
                this.queryTicketByType();
            },
            init:function(){
                this.$nextTick(function() {
                    this.eventChangeTrendLine();
                    this.totalEventsChartLine();
                    this.averageResponseTimeLine();
                });
            },
            // 事件变化趋势统计图
            eventChangeTrendLine: function(){
                this.chartEventChangeTrend=this.$echarts.init(document.getElementById("eventChangeTrend"));
                this.chartEventChangeTrend.setOption({
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data:['P1','P2','P3','P4']
                    },
                    xAxis: {
                        type: 'category',
                        data: this.trendTimeList
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    series: [
                        {
                            name:'P1',
                            type:'bar',
                            barGap:'0%',
                            barMinHeight:1,
                            barWidth : 30,
                            stack:'事件',
                            data:this.p1EventTrend
                        },
                        {
                            name:'P2',
                            type:'bar',
                            barGap:'0%',
                            barMinHeight:1,
                            barWidth : 30,
                            stack:'事件',
                            data:this.p2EventTrend
                        },
                        {
                            name:'P3',
                            type:'bar',
                            barGap:'0%',
                            barMinHeight:1,
                            barWidth : 30,
                            stack:'事件',
                            data:this.p3EventTrend
                        },
                        {
                            name:'P4',
                            type:'bar',
                            barGap:'0%',
                            barMinHeight:1,
                            barWidth : 30,
                            stack:'事件',
                            data:this.p4EventTrend
                        },
                        {
                            name: this.$t('KPI.total'),
                            type:'line',
                            data:this.sumEventTrend,
                            itemStyle:{
                                normal:{
                                    lineStyle:{
                                        type:'dotted'  //'dotted'虚线 'solid'实线
                                    }
                                }
                            }
                        }
                    ]
                })
            },
            // 事件总数
            totalEventsChartLine:function(){
                this.totalEventsChart=this.$echarts.init(document.getElementById("totalEvents"));
                this.totalEventsChart.setOption({
                    title: {
                        text: this.allStatusTicket,
                        subtext: this.$t('KPI.totalEvent'),
                        x: '52%',
                        y: 'center',
                        textStyle:{
                            fontStyle:'normal',
                            fontWeight:"normal",
                            fontSize:18
                        },
                        subtextStyle:{
                            fontStyle:'normal',
                            fontWeight:"normal",
                            fontSize:13
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)',
                        confine: true
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: this.problemValueList
                    },
                    series: [
                        {
                            name: this.$t('KPI.total'),
                            type: 'pie',
                            center: ['60%', '50%'],
                            radius: ['55%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false
                            },
                            emphasis: {
                                label: {
                                    show: false,
                                    fontSize: '12',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: this.resultList
                        }
                    ]
                });
            },
            // 平均响应时间
            averageResponseTimeLine:function(){
                this.chartAverageResponseTime=this.$echarts.init(document.getElementById("averageResponseTime"));
                this.chartAverageResponseTime.setOption({
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data:this.problemValueLists
                    },
                    color:['#47bac1', '#e5c55f','#798ee1','#ccc'],
                    series : [
                        {
                            name: this.$t('KPI.caseSLAAtEachLevel'),
                            type: 'pie',
                            radius : '70%',
                            center: ['55%', '50%'],
                            label: {
                                normal: {
                                    show: true
                                }
                            },
                            data:this.resultLists,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })

            },
            searchPriority:function(){
                this.getSlaTicketAnalyzeStatistics();
            },
            /************************************案例统计*****************************************/
            // 案例统计
            getTicketStatistics:function(){
                this.$api.ticket.getTicketStatistics({
                    "startTime": this.monthTable,
                    "companyId": this.companyIdTable,
                    "isDayShift": this.isDayShift,
                    "coefficient": this.coefficient
                })
                .then(res => {
                    // 案例统计
                    this.ticketCellListDTO=res.data.ticketCellList;
                    this.ticketCellListLine=res.data.line;
                })
            },
            // 切换白班夜班
            isDayShiftChange:function(){
                this.getTicketStatistics();
            },
            // 切换系数
            coefficientChange:function(){
                this.getTicketStatistics();
            },
            // 导出
            ticketStatisticsDownload:function(){
                this.$Message.loading({
                    duration: 0,
                    content: 'Loading'
                })
                // 下载Excel 文件
                this.$api.ticket.exportTicketStatistics({
                    "startTime": this.monthTable,
                    "companyId": this.companyIdTable,
                    "isDayShift": this.isDayShift,
                    "coefficient": this.coefficient
                })
                .then(res => {
                    let fileName = '案例统计.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            /************************************公司贡献******************************************/
            // 公司贡献
            getCompanyContributionStatistics:function(){
                this.$api.ticket.getCompanyContributionStatistics({
                    "startTime": this.monthTable,
                    "companyId": this.companyIdTable
                })
                .then(res => {
                    // 公司贡献
                    this.documentDTO=res.data.ticketCellList;
                    this.documentLine=res.data.line;
                })
            },
            // 导出
            ticketDocumentDownload:function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.ticket.exportCompanyContributionStatistics({
                    "startTime": this.monthTable,
                    "companyId": this.companyIdTable
                })
                .then(res => {
                    let fileName = '公司贡献.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            /************************************SLA******************************************/
            // SLA
            getSlaStatistics:function(){
                this.$api.ticket.getSlaStatistics({
                    "startTime": this.monthTable,
                    "companyId": this.companyIdTable
                })
                .then(res => {
                    this.SLAData=res.data;
                })
            },
            // 点击详情
            caseDetail: function(row){
                this.$router.push({path:'/cases/caseDetail/',query: {id: row.id}});
            },
            //导出
            exportSlaDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.ticket.exportSlaParticulars({
                    "startTime": this.monthTable,
                    "companyId": this.companyIdTable
                })
                .then(res => {
                    let fileName = '不满足SLA案例统计.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            /*********************年月************************/
            // 切换年月
            searchMonthTable:function(){
                this.getTicketStatistics();
                this.getCompanyContributionStatistics();
                this.getSlaStatistics();
            },
            // 切换公司
            companyIdTableChange:function(){
                this.getTicketStatistics();
                this.getCompanyContributionStatistics();
                this.getSlaStatistics();
            },
        }
    }
</script>

<style scoped>
    .KPI-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        padding: 10px;
        float:left;
        color:#000;
    }
    .kpi-table
    {
        width: 100%;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    .kpi-table th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    .kpi-table td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    a{
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/key_performance_indication/KeyPerformanceIndication.vue